import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
    // Collect all unique gallery IDs on the page so that multiple gallery
    // blocks stay independent — each opens its own lightbox sequence.
    const galleryIds = new Set(
        [...document.querySelectorAll('.gallery__item[data-gallery]')]
            .map(el => el.dataset.gallery)
    );

    galleryIds.forEach(id => {
        GLightbox({
            selector:        `[data-gallery="${id}"]`,
            touchNavigation: true,
            loop:            true,
            autoplayVideos:  false,
            descPosition:    'bottom',
            skin:            'clean',
        });
    });
});
